import React, { lazy } from 'react';
import { Typography } from '@mui/material';
import { DS_palette as corePalette } from 'mui/base/theme/DS_Tokens/core';
import DS_BasicCard from '../../elements/DS_BasicCard';
import DS_MaxWidthLayout from '../../elements/DS_MaxWidthLayout';
import DS_InfoGraphicCard from './DS_InfoGraphicCard';
import { StyledSection, StyledGrid, StyledMarkdown } from './DS_InfoGraphicsStyles';

const Markdown = lazy(() => import('mui/components/elements/DS_Markdown'));

const DS_InfoGraphics = data => {
  const { headline, infoGraphicCards, colorVariant, enumeration, layoutVariant, description, isRichText } = data;

  const gradient = `linear-gradient( 0deg, hsl(229deg 93% 96%) 0%, hsl(182deg 62% 84%) 19%, hsl(169deg 54% 74%) 29%, hsl(89deg 36% 78%) 44%, hsl(17deg 96% 92%) 69%, hsl(17deg 91% 82%) 100% );`;

  const colorMappings = {
    'light mint': corePalette.mint[50],
    'light pink': corePalette.flamingo[50],
  };

  const color = colorMappings[colorVariant] || corePalette.blue[50];

  return (
    <StyledSection isRichText={isRichText}>
      <DS_MaxWidthLayout>
        <DS_BasicCard backgroundColor={color} backgroundImage={colorVariant === 'gradient' ? gradient : null}>
          <Typography component="h2" variant="DS_h3">
            {headline}
          </Typography>
          <StyledGrid $layoutVariant={layoutVariant} isRichText={isRichText}>
            {infoGraphicCards.map((card, index) => {
              return (
                <DS_InfoGraphicCard
                  key={`${card.id}-${index}`}
                  card={card}
                  index={index}
                  enumeration={enumeration}
                  layoutVariant={layoutVariant}
                  isRichText={isRichText}
                />
              );
            })}
          </StyledGrid>
          {description && (
            <StyledMarkdown>
              <div>
                <Markdown>{description.markdown.html}</Markdown>
              </div>
            </StyledMarkdown>
          )}
        </DS_BasicCard>
      </DS_MaxWidthLayout>
    </StyledSection>
  );
};

export default DS_InfoGraphics;
